export default "__VITE_ASSET__DC7pDvgF__";